<template>
    <button class="button" 
        :disabled="disabled"
        :class="{'disabled': disabled}"
        @click.stop="$emit('click')"
        :style="{'min-height': minHeight}"
    >
        <span v-if="!isLoading">{{ text }}</span>
        <base-spinner
            :is-local="true"
            :is-loading="isLoading"
            v-else
            :spinner-color="spinnerColor"
            :size="spinnerSize"
        />
    </button>
</template>

<script>
import BaseSpinner from './BaseSpinner.vue'
export default {
  components: { BaseSpinner },
    name: 'BaseButton',
    props: {
        text: String,
        isLoading: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        spinnerColor: {
            type: String,
            default() {
                return 'var(--base-button-spinner-color)';
            }
        },
        spinnerSize: {
            type: String,
            default() {
                return '5px';
            }
        },
        minHeight: {
            type: String,
            default() {
                return '40px';
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.button {
    width: 100%;
    height: 100%;
    max-height: 40px;
    min-height: 40px;
    padding: .5rem 1rem;
    gap: 8px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--base-button-bgc);
    border: none;
    outline: none;
    border-radius: 10px;
    font-weight: 600;
    font-size: 14px;
    line-height: 22px;
    color: var(--base-button-color);
    cursor: pointer;

    &.disabled {
        background-color: rgba(64, 191, 123, 0.5);
    }

    &:hover:not(.disabled) {
      background-color: #33a568;
    }
}
</style>